export const balanceListSelector = (state) => state.transferAct.balance;
export const balanceStockSelector = (state) => state.transferAct.stockID;
export const subtypesListSelector = (state) => state.transferAct.subtypes;
export const categoriesListSelector = (state) => state.transferAct.categories;

export const rentStatisticSelector = (state) => state.transferAct.statistic;
export const rentStatisticRejectReasonSelector = (state) => state.transferAct.statisticRejectReason;

export const rentListSelector = (state) => state.transferAct.rentList;
export const rentArchiveListSelector = (state) => state.transferAct.rentArchiveList;
export const reserveListSelector = (state) => state.transferAct.reserveList;

export const rentSelector = (state) => state.transferAct.rent;
export const rentContinueSelector = (state) => state.transferAct.rentContinue;
export const rentExitSelector = (state) => state.transferAct.rentExit;
export const reserveSelector = (state) => state.transferAct.reserve;
export const reserveInitalSelector = (state) => state.transferAct.reserveInital;
export const accrualListSelector = (state) => state.transferAct.accrualList;
export const rentInitalSelector = (state) => state.transferAct.rentInital;
export const rentTableListSelector = (state) => state.transferAct.tableList;
export const rentTableListhasNextSelector = (state) => state.transferAct.hasNext;
export const actStatusesSelector = (state) => state.transferAct.actStatuses;
